// extracted by mini-css-extract-plugin
export var sbShowMain = "itemsList-module--sb-show-main---68XV";
export var wrapper = "itemsList-module--wrapper--MzILT";